import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { orderRoutes } from "./order.route";

@NgModule({
  imports: [RouterModule.forChild(orderRoutes)],
  exports: [RouterModule],
})
export class OrderRoutingModule {}
